.crumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.4rem;
}

.parent {
  color: #e3e4e7;

  &:hover {
    color: white;
  }
}
